<template>
    <div class="fixed-header-page">
        <header-nav :title="title"></header-nav>
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            title: String
        },
        data() {
            return {
            }
        },
        created() {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/page/index.vue